/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownPostgradOrganisation } from '../models/db_DropdownPostgradOrganisation';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PostgradOrganisations {
    /**
     * Get a list of postgrad organisations
     * @returns db_DropdownPostgradOrganisation OK
     * @throws ApiError
     */
    public static listPostgradOrganisations(): CancelablePromise<Array<db_DropdownPostgradOrganisation>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/postgrad-organisations',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
